import { MetricsCategory } from '@/lib/utils/metrics.utils';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { useMetrics } from './useMetrics';

export function useHandlePaymentStatus() {
  const searchParams = useSearchParams();
  const { trackEvent } = useMetrics();
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState<'success' | 'failed'>();

  useEffect(() => {
    const paymentCompleted = searchParams?.get('paymentCompleted');
    if (paymentCompleted === 'true') {
      setPaymentStatus('success');
      setShowPaymentDialog(true);

      trackEvent({
        category: MetricsCategory.USER_ACTIVITY,
        action: 'PaymentCompleted',
        label: 'Payment Success',
        value: 1,
      });
    } else if (paymentCompleted === 'false') {
      setPaymentStatus('failed');
      setShowPaymentDialog(true);

      trackEvent({
        category: MetricsCategory.USER_ACTIVITY,
        action: 'PaymentCompleted',
        label: 'Payment Failed',
        value: 0,
      });
    }
  }, [searchParams, trackEvent]);

  return { showPaymentDialog, setShowPaymentDialog, paymentStatus };
}
